import React from 'react';
import PropTypes from 'prop-types';
import { causeloss, location } from 'assets/icon';

import { Typography, Status } from '../../../alf-design';

const ClaimDetailsHeader = ({ index, claim }) => {
  const renderCircleIcon = (icon) => (
    <img alt="" src={icon} className="icon" style={{ width: 16, height: 16 }} />
  );
  const { street, city, state, zip } = claim?.lossLocation || {};
  const address = [street ? street + ',' : null, city, state, zip]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      <div className="flex justify-between items-center pt-[21px]">
        <div className="flex items-center gap-[12px] mb-[16px]">
          <Typography
            id={`headerClaimNumber-${index}`}
            type="h2-claim"
            component="h2"
          >
            {`Claim #${claim?.claimNumber}`}
          </Typography>
          <Status id={`headerClaimStatus-${index}`} status={claim?.claimStatus}>
            {claim?.claimStatus}
          </Status>
        </div>
      </div>
      <div className="flex gap-[23px]">
        <div className="flex items-center gap-[8px]">
          {renderCircleIcon(causeloss)}
          <Typography
            id={`headerClaimLossCause-${index}`}
            type="caption1"
            component="span"
            className=""
          >
            {claim?.loss?.cause}
          </Typography>
        </div>
        <div className="flex items-center gap-[8px]">
          {address ? renderCircleIcon(location) : null}
          <Typography
            id={`headerClaimLossLocation-${index}`}
            type="caption1"
            component="span"
            className=""
          >
            {address}
          </Typography>
        </div>
      </div>
    </>
  );
};

ClaimDetailsHeader.propTypes = {
  claim: PropTypes.object.isRequired,
};

export default ClaimDetailsHeader;
